import React, { useState, useEffect, forwardRef } from 'react';
import PropTypes from 'prop-types';
import MaterialTable from 'material-table';
import axios from 'axios'
import Snackbar from '@material-ui/core/Snackbar';
import MySnackbarContentWrapper from '../../../../layouts/SnackBars';

import AddBox from '@material-ui/icons/AddBox';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

const MoneyTypeTable = props => {
  const [columns] = useState([

    { title: 'รายการ', field: 'money_type_name' },
    {
      title: 'รายการได้/หัก',
      field: 'income_type_id',
      lookup: { 1: 'รายการได้', 2: 'รายการหัก', 3: 'บัญชีเงินฝาก',4 : 'โครงการกิจกรรม' },
    },
    {
      title: 'สถานะการใช้งาน',
      field: 'money_status_id',
      lookup: { 1: 'ใช้งาน', 0: 'ยกเลิกใช้งาน' },
    },
    { title: 'เรียงลำดับ', field: 'order_id', type: 'numeric' },
  ]);

  const [url] = useState('https://eslip.snru.ac.th/backend/api/moneytype');
  const [values, setValues] = useState();

  const [data, setData] = useState([]);
  const [openSnack, setOpenSnack] = useState(false);
  const [snackMessage, setSnackMessage] = useState();
  const [snackVariant, setSnackVariant] = useState('success');

  useEffect(() => {
    let source = axios.CancelToken.source();
    const fetchData = async () => {
      try {
        const result = await axios(url, {
          cancelToken: source.token
        });
        setData(result.data.data);
      } catch (error) {

      }
    };
    fetchData();
    return () => {
      console.log("AxiosCancel: unmounting");
      source.cancel();
    };
  }, [values]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnack(false);
  };

  return (
    <div>
      <MaterialTable
        icons={tableIcons}
        title="ข้อมูลรายการหัก/รายการได้/บัญชีเงินฝาก/โครงการกิจกรรม"
        columns={columns}
        data={data}
        editable={{
          onRowAdd: async (newData) => {
            try {
              const apiUrl = 'https://eslip.snru.ac.th/backend/api/moneyType/saveData';
              const response = await axios.post(apiUrl, newData);
              setValues(newData);

              setSnackVariant('success');
              setSnackMessage('บันทึกข้อมูลแแล้ว');
              setOpenSnack(true);
            } catch (error) {
              setSnackVariant('error');
              setSnackMessage(error.response.data.error.message)
              setOpenSnack(true);
            }
          },
          onRowUpdate: async (newData, oldData) => {
            try {
              const apiUrl = 'https://eslip.snru.ac.th/backend/api/moneyType/updateData';
              const response = await axios.post(apiUrl, newData);
              setValues(newData);

              setSnackVariant('success');
              setSnackMessage(response.data.message);
              setOpenSnack(true);
            } catch (error) {
              setSnackVariant('error');
              setSnackMessage(error.response.data.error.message)
              setOpenSnack(true);
            }
          },
          onRowDelete: async oldData => {
            try {
              const apiUrl = 'https://eslip.snru.ac.th/backend/api/moneyType/deleteData';
              const response = await axios.post(apiUrl, oldData);
              setValues(oldData);

              setSnackVariant('success');
              setSnackMessage(response.data.message);
              setOpenSnack(true);
            } catch (error) {
              setSnackVariant('error');
              setSnackMessage(error.response.data.error.message)
              setOpenSnack(true);

            }
          }
        }}
      />
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        open={openSnack}
        autoHideDuration={2000}
        onClose={handleClose}
      >
        <MySnackbarContentWrapper
          onClose={handleClose}
          variant={snackVariant}
          message={snackMessage}
        />
      </Snackbar>
    </div>
  )
};

export default MoneyTypeTable;
